import React from 'react';
// import { useNavigate } from 'react-router-dom';

import { ReactComponent as AttachedUserIcon } from '../../../../assets/device-hub/dasnboard/attched-device.svg';
import { ReactComponent as AvailableIcon } from '../../../../assets/device-hub/dasnboard/available.svg';
import { ReactComponent as BlockedDeviceIcon } from '../../../../assets/device-hub/dasnboard/blocked-device.svg';
import { ReactComponent as ChargingIcon } from '../../../../assets/device-hub/dasnboard/charging.svg';
import { ReactComponent as FinishingIcon } from '../../../../assets/device-hub/dasnboard/finishing.svg';
import { ReactComponent as OnlineDeviceIcon } from '../../../../assets/device-hub/dasnboard/online-device.svg';
import { ReactComponent as PreparingIcon } from '../../../../assets/device-hub/dasnboard/preparing.svg';
// eslint-disable-next-line unicorn/prevent-abbreviations
import { ReactComponent as SuspendedEvIcon } from '../../../../assets/device-hub/dasnboard/suspendedEV.svg';
import { ReactComponent as SuspendedEvseIcon } from '../../../../assets/device-hub/dasnboard/suspendedEVSE.svg';
import { ReactComponent as TotalConnectorIcon } from '../../../../assets/device-hub/dasnboard/total-connecter.svg';
import { ReactComponent as DashDeviceIcon } from '../../../../assets/device-hub/dasnboard/total-device.svg';
// import { ReactComponent as UnavailableIcon } from '../../../../assets/device-hub/dasnboard/unavailable.svg';
import { ReactComponent as UnknownIcon } from '../../../../assets/device-hub/dasnboard/unknow.svg';
import { ReactComponent as InfoIcon } from '../../../../assets/icons/info-icon.svg';
import { useAppSelector } from '../../../../redux/hooks';
// import MyButton from '../../../../shared-components/button/Button';
// import SelectField from '../../../../shared-components/select-field/SelectField';

import './scss/dashboard-widgets.scss';

/**
 * Renders the dashboard widgets including quick stats, charts, and alerts
 * @returns {any} JSX element
 */
function DashboardWidgets() {
  // const navigate = useNavigate();
  // const [dateFilter, setDateFilter] = useState('today');
  const { deviceStats, connectorStats } = useAppSelector((state) => state.deviceHub);

  /**
   * Navigate to Add Device page
   */
  // const handleAddDevice = () => {
  //   navigate('/ev-admin/ev-device-hub/add-device');
  // };

  return (
    <div className="dashboard-widgets-container">
      {/* Header Section with Date Filter and Add Device Button */}
      {/* <div className="dashboard-header">
        <div className='header-details'>
          <h4>Device Hub</h4>
          <p>Manage and monitor your devices here</p>
        </div>
        <div className="dashboard-header-actions">
          <div className="date-filter-group">
            <SelectField
              name="dateFilter"
              selectedValue={dateFilter}
              placeholder="Select Period"
              options={[
                { value: 'today', label: 'Today' },
                { value: 'yesterday', label: 'Yesterday' },
                { value: 'last7days', label: 'Last 7 Days' },
                { value: 'last30days', label: 'Last 30 Days' },
              ]}
              onChangeValue={(_name, value) => setDateFilter(value)}
            />
          </div>
          <MyButton
            label="+ Add Device"
            buttonType="primary"
            onClickFunc={handleAddDevice}
          />
        </div>
      </div> */}
      {/* Top Section: Quick Info Cards */}
      <div className="quick-info-section">
        {/* Device Quick Info */}
        <div className="info-card">
          <div className="info-header">
            <h3>Device Quick Info</h3>
            <span
              className="info-icon-tooltip"
              data-tooltip="Provides a high-level overview of EV charger devices registered in the platform, including operational, connectivity, and assignment status.">
              <InfoIcon />
            </span>
          </div>
          <div className="info-grid device-info-grid">
            <div className="info-item">
              <div className="info-label-group">
                <span className="info-label info-label--teal">Total Device</span>
                <span className="info-value">{deviceStats.totalDevices || 0}</span>
              </div>
              <div className="info-icon bg-light-gray">
                <DashDeviceIcon className='icon' />
              </div>
            </div>
            <div className="info-item">
              <div className="info-label-group">
                <span className="info-label info-label--teal">Online Device</span>
                <span className="info-value">{deviceStats?.onlineDeviceCount ?? 0}</span>
              </div>
              <div className="info-icon bg-light-green">
                <OnlineDeviceIcon width="16" height="16" />
              </div>
            </div>
            <div className="info-item">
              <div className="info-label-group">
                <span className="info-label info-label--teal">Attached</span>
                <span className="info-value">{deviceStats.cpoAssociatedCount || 0}</span>
              </div>
              <div className="info-icon bg-light-gray">
                <AttachedUserIcon width="16" height="16" />
              </div>
            </div>
            {/* <div className="info-item">
              <div className="info-label-group">
                <span className="info-label info-label--teal">Not Attached</span>
                <span className="info-value">{deviceStats.nonAssociatedCount || 0}</span>
              </div>
              <div className="info-icon bg-light-gray"><PersonIcon width="16" height="16" /></div>
            </div> */}
            <div className="info-item">
              <div className="info-label-group">
                <span className="info-label info-label--teal">Blocked Device</span>
                <span className="info-value">{deviceStats?.blockedDeviceCount || 0}</span>
              </div>
              <div className="info-icon bg-light-red">
                <BlockedDeviceIcon width="16" height="16" />
              </div>
            </div>
            {/* <div className="info-item">
              <div className="info-label-group">
                <span className="info-label info-label--alert">Active Alerts</span>
                <span className="info-value">200</span>
              </div>
              <div className="info-icon bg-light-red"><AlertIcon width="16" height="16" /></div>
            </div> */}
          </div>
        </div>

        {/* Connector Quick Info */}
        <div className="info-card">
          <div className="info-header">
            <h3>Connector Quick Info</h3>
            <span
              className="info-icon-tooltip"
              data-tooltip="Provides a real-time summary of connector availability and charging session states across all registered EV chargers.">
              <InfoIcon />
            </span>
          </div>
          <div className="info-grid">
            <div className="info-item">
              <div className="info-label-group">
                <span className="info-label info-label--purple">Total</span>
                <span className="info-value">{connectorStats?.total ?? 0}</span>
              </div>
              <div className="info-icon bg-light-gray">
                <TotalConnectorIcon />
              </div>
            </div>
            <div className="info-item">
              <div className="info-label-group">
                <span className="info-label info-label--green">Available</span>
                <span className="info-value">{connectorStats?.available ?? 0}</span>
              </div>
              <div className="info-icon bg-light-gray">
                <AvailableIcon className='available' />
              </div>
            </div>
            <div className="info-item">
              <div className="info-label-group">
                <span className="info-label info-label--blue">Charging</span>
                <span className="info-value">{connectorStats?.charging ?? 0}</span>
              </div>
              <div className="info-icon bg-light-gray">
                <ChargingIcon className='charging' />
              </div>
            </div>
            <div className="info-item">
              <div className="info-label-group">
                <span className="info-label info-label--orange">Preparing</span>
                <span className="info-value">{connectorStats?.preparing ?? 0}</span>
              </div>
              <div className="info-icon bg-light-gray">
                <PreparingIcon className='preparing' />
              </div>
            </div>
            <div className="info-item">
              <div className="info-label-group">
                <span className="info-label info-label--teal">Finishing</span>
                <span className="info-value">{connectorStats?.finishing ?? 0}</span>
              </div>
              <div className="info-icon bg-light-gray">
                <FinishingIcon className='finishing' />
              </div>
            </div>
            <div className="info-item">
              <div className="info-label-group">
                <span className="info-label info-label--dark">Unknown</span>
                <span className="info-value">{connectorStats?.unknown ?? 0}</span>
              </div>
              <div className="info-icon bg-light-gray">
                <UnknownIcon className='unknown' />
              </div>
            </div>
            {/* <div className="info-item">
              <div className="info-label-group">
                <span className="info-label info-label--gray">Unavailable</span>
                <span className="info-value">{connectorStats?.unavailable ?? 0}</span>
              </div>
              <div className="info-icon bg-light-gray">
                <UnavailableIcon width="16" height="16" />
              </div>
            </div> */}
            <div className="info-item">
              <div className="info-label-group">
                <span className="info-label info-label--alert">Faulted</span>
                <span className="info-value">{connectorStats?.faulted ?? 0}</span>
              </div>
              <div className="info-icon bg-light-gray">
                <BlockedDeviceIcon className='faulted' />
              </div>
            </div>
            <div className="info-item">
              <div className="info-label-group">
                <span className="info-label info-label--pink">SuspendedEV</span>
                <span className="info-value">{connectorStats?.suspendedEv ?? 0}</span>
              </div>
              <div className="info-icon bg-light-gray">
                <SuspendedEvIcon className='suspended-ev' />
              </div>
            </div>
            <div className="info-item">
              <div className="info-label-group">
                <span className="info-label info-label--yellow">SuspendedEVSE</span>
                <span className="info-value">{connectorStats?.suspendedEvse ?? 0}</span>
              </div>
              <div className="info-icon bg-light-gray">
                <SuspendedEvseIcon className='suspended-evse' />
              </div>
            </div>
            <div className="info-item">
              <div className="info-label-group">
                <span className="info-label info-label--yellow">Reserved</span>
                <span className="info-value">{connectorStats?.reservations ?? 0}</span>
              </div>
              <div className="info-icon bg-light-gray">
                <SuspendedEvseIcon className='reserved' />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Middle Section: Charts & Alerts */}
      {/* <div className="charts-section"> */}
      {/* Device State Chart */}
      {/* <div className="chart-card device-state-card">
          <div className="chart-header">
            <h3>Device State</h3>
            <p>This data based how many device attached with Partner/CPO</p>
          </div>
          <div className="chart-content">
            <div className="bar-chart-mock">
              {['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].map((month, index) => (
                <div key={index} className="bar-group">
                  <div className="bars">
                    <div className="bar associated" style={{ height: `${Math.random() * 40 + 40}%` }} />
                    <div className="bar non-associated" style={{ height: `${Math.random() * 30 + 20}%` }} />
                    <div className="bar blocklist" style={{ height: `${Math.random() * 20 + 10}%` }} />
                  </div>
                  <span className="month-label">{month}</span>
                </div>
              ))}
            </div>
            <div className="chart-legend">
              <div className="legend-item"><span className="dot bg-green" /> Associated <strong>800</strong></div>
              <div className="legend-item"><span className="dot bg-orange" /> Non Associated <strong>200</strong></div>
              <div className="legend-item"><span className="dot bg-red" /> Blocklist <strong>150</strong></div>
            </div>
          </div>
        </div> */}

      {/* Device Performance Chart */}
      {/* <div className="chart-card device-performance-card">
          <div className="chart-header">
            <h3>Device Performance</h3>
            <p>Tracks charger operational efficiency by measuring below values</p>
          </div>
          <div className="performance-legend-top">
            <div className="legend-items">
              <div className="legend-item"><span className="square bg-green" /> Optimal</div>
              <div className="legend-item"><span className="square bg-orange" /> Sub - Optimal</div>
              <div className="legend-item"><span className="square bg-red" /> Critical</div>
            </div>
            <div className="toggle-group">
              <button type="button" className="toggle-btn active">Health Score</button>
              <button type="button" className="toggle-btn">Output</button>
            </div>
          </div>
          <div className="chart-content horizontal-bars">
            {['Device 1', 'Device 2', 'Device 3', 'Device 4', 'Device 5', 'Device 6'].map((device, index) => {
              let barClass = 'bg-green';
              let width = '100%';
              if (index === 2) {
                barClass = 'bg-orange';
                width = '80%';
              }
              if (index === 5) {
                barClass = 'bg-red';
                width = '60%';
              }
              return (
                <div key={index} className="horizontal-bar-row">
                  <span className="device-name">{device}</span>
                  <div className="bar-track">
                    <div className={`bar-fill ${barClass}`} style={{ width }} />
                  </div>
                </div>
              );
            })}
          </div>
        </div> */}

      {/* Live Device Alerts */}
      {/* <div className="chart-card live-alerts-card">
          <div className="chart-header">
            <h3>Live Device Alerts</h3>
            <p>Tracks active alerts generated by Device in real time</p>
          </div>
          <div className="alerts-list">
            <div className="alert-item">
              <div className="alert-icon-wrap bg-light-red"><AlertIcon width="16" height="16" className="text-red" /></div>
              <div className="alert-details">
                <span className="alert-title">Alert 1</span>
                <span className="alert-time">2min ago <span className="divider">|</span> Device 1</span>
              </div>
            </div>
            <div className="alert-item">
              <div className="alert-icon-wrap bg-light-orange"><AlertIcon width="16" height="16" className="text-orange" /></div>
              <div className="alert-details">
                <span className="alert-title">Alert 2</span>
                <span className="alert-time">2min ago <span className="divider">|</span> Device 2</span>
              </div>
            </div>
            <div className="alert-item">
              <div className="alert-icon-wrap bg-light-blue"><AlertIcon width="16" height="16" className="text-blue" /></div>
              <div className="alert-details">
                <span className="alert-title">Alert 3</span>
                <span className="alert-time">2min ago <span className="divider">|</span> Device 3</span>
              </div>
            </div>
            <div className="alert-item">
              <div className="alert-icon-wrap bg-light-red"><AlertIcon width="16" height="16" className="text-red" /></div>
              <div className="alert-details">
                <span className="alert-title">Alert 4</span>
                <span className="alert-time">1min ago <span className="divider">|</span> Device 4</span>
              </div>
            </div>
          </div>
        </div> */}
      {/* </div> */}
    </div>
  );
}

export default DashboardWidgets;
